import * as React from "react";
import { Contact } from "./components/contact/Contact";
import { render } from "react-dom";

render(
    <Contact></Contact>,
    document.querySelector(".contact")
  );